/* tslint:disable */
/* eslint-disable */
/**
 * Apideck
 * The Apideck OpenAPI Spec: SDK Optimized
 *
 * The version of the OpenAPI document: 10.13.0
 * Contact: support@apideck.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface AgedReportFilter
 */
export interface AgedReportFilter {
  /**
   * Filter by customer id
   * @type {string}
   * @memberof AgedReportFilter
   */
  customer_id?: string
  /**
   * Filter by supplier id
   * @type {string}
   * @memberof AgedReportFilter
   */
  supplier_id?: string
  /**
   * The cutoff date for considering transactions
   * @type {string}
   * @memberof AgedReportFilter
   */
  report_as_of_date?: string
  /**
   * Number of periods to split the aged creditors report into
   * @type {number}
   * @memberof AgedReportFilter
   */
  period_count?: number
  /**
   * Length of each period in days
   * @type {number}
   * @memberof AgedReportFilter
   */
  period_length?: number
}

export function AgedReportFilterFromJSON(json: any): AgedReportFilter {
  return AgedReportFilterFromJSONTyped(json, false)
}

export function AgedReportFilterFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AgedReportFilter {
  if (json === undefined || json === null) {
    return json
  }
  return {
    customer_id: !exists(json, 'customer_id') ? undefined : json['customer_id'],
    supplier_id: !exists(json, 'supplier_id') ? undefined : json['supplier_id'],
    report_as_of_date: !exists(json, 'report_as_of_date') ? undefined : json['report_as_of_date'],
    period_count: !exists(json, 'period_count') ? undefined : json['period_count'],
    period_length: !exists(json, 'period_length') ? undefined : json['period_length']
  }
}

export function AgedReportFilterToJSON(value?: AgedReportFilter | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    customer_id: value.customer_id,
    supplier_id: value.supplier_id,
    report_as_of_date: value.report_as_of_date,
    period_count: value.period_count,
    period_length: value.period_length
  }
}
